import ObjectFun from './ObjectFun';
import { Result, Result2, Result3 } from './Result';
import BigNumber from 'bignumber.js'

export default class Queryable<T> extends Array<T> {
    constructor(struct?: Array<T>) {
        super()
        this.structCount = 0;
        this.nextIdex = 0;
        if (struct !== undefined) {
            for (let i = 0; i < struct.length; i++)
                this[i] = struct[i];
            this.structCount = struct.length
        }
    }

    //#region  成员变量
    private nextIdex: number;

    private structCount: number;
    public get length(): number {
        return this.structCount;
    }

    [x: number]: T;
    //#endregion

    //#region 成员函数
    Where(func: Result<T, boolean>): Queryable<T>;
    Where<Ts>(func: Result2<T, Ts, boolean>): Queryable<T>;
    Where(func: any): any {
        let Temp: Queryable<T> = new Queryable<T>();
        for (let i = 0; i < this.structCount; i++)
            if (func(this[i], i))
                Temp.Add(this[i]);
        return Temp;
    }

    finds(func: Result<T, boolean>): T {
        for (let i = 0; i < this.length; i++) {
            if (func(this[i])) {
                return this[i];
            }
        }
        return null;
    }

    OrderBy(func: Result2<T, T, boolean>): this {
        let temp: T = null;
        for (let i = 0; i < this.structCount - 1; i++) {
            for (let j = i + 1; j < this.structCount; j++)
                if (func(this[i], this[j])) {
                    temp = this[i];
                    this[i] = this[j];
                    this[j] = temp;
                }
        }
        return this;
    }

    /**
     * 分组
     * @param filed 分组字段
     * @returns ObjectFun<T>
     */
    GroupByField(filed: string): ObjectFun<T> {
        const temp = new ObjectFun<T>()
        this.map(item => {
            const key = item[filed]
            if (!temp[key])
                temp[key] = new Queryable<any>();
            temp[key].Add(item);
        });
        return temp;
    }

    /**
    * @param {Array<String>} aggFileds 分组依赖字段
    * @returns {Object} groupObject 分组后对象
    */
    AggregationItem(aggFileds: Array<string>) {
        let aggTemp = this[0]
        const filed = aggFileds.length === 1 ? aggFileds[0] : undefined
        if (this.length > 1) {
            const reduce = this.reduce((item1, item2) => {
                let add = {}
                if (filed) {
                    add[filed] = Number.parseFloat(new BigNumber(item1[filed]).plus(item2[filed]).toString())
                } else {
                    aggFileds.map(filed => {
                        add[filed] = Number.parseFloat(new BigNumber(item1[filed]).plus(item2[filed]).toString())
                    })
                }
                return add as T
            })
            aggTemp = { ...aggTemp, ...reduce }
        }
        return aggTemp;
    }


    /**
     *
     * @param condit (item: T, itemNext: T): boolean
     * @param aggFileds 聚合字段
     * @returns Queryable<T>
     */
    byItemAggregation(condit: Result2<T, T, boolean>, aggFileds: Array<string>) {
        const temp = new Queryable<T>()

        let aggTemp = null
        const callBack = (item: T, nextItem: T, ends: boolean) => {

            if (ends && !nextItem) {
                temp.push(item)
                return
            }

            if (!aggTemp) {
                aggTemp = { ...item }
            }

            const condits = condit(item, nextItem)
            if (condits) {
                aggFileds.forEach(filed => {
                    aggTemp[filed] = Number
                        .parseFloat(
                            new BigNumber(aggTemp[filed]).plus(nextItem[filed]).toString()
                        )
                })
            }
            if (ends) {
                temp.push(aggTemp)
                aggTemp = null
            }
            return condits
        }
        this.fast(callBack)
        return temp
    }

    /**
     *
     * @param condit (item: T, itemNext: T): boolean
     * @returns void
     */
    fast(condit: Result3<T, T, boolean, boolean>) {
        const arr: Queryable<T> = this
        const isExclude = []

        let i = 0
        if (arr.length > 1) {
            for (; i < (arr.length - 1); i++) {
                if (isExclude[i]) continue
                isExclude[i] = true

                for (let j = i + 1; j < arr.length; j++) {
                    if (isExclude[j]) continue
                    const condits = condit(arr[i], arr[j], j === (arr.length - 1))
                    if (condits) {
                        isExclude[j] = true
                    }
                }
            }
        }
        if (!isExclude[i]) {
            condit(arr[i], null, true)
        }
    }

    // then(func: Result2<T, T, boolean>): this {
    //     return this.OrderBy(func);
    // }

    maps(func: Result2<T, number, any>): Queryable<T> {
        let Temp: Queryable<T> = new Queryable<T>();
        for (let i = 0; i < this.structCount; i++)
            Temp.Add(func(this[i], i));
        return Temp;
    }

    Iterator(func: Result2<T, number, any>) {
        for (let i = 0; i < this.structCount; i++)
            func(this[i], i);
    }

    Insert(joinQueryable: this) {
        for (let i = 0; i < joinQueryable.structCount; i++)
            this[this.structCount++] = joinQueryable[i];
        return this;
    }

    Skip(skipIndex: number) {
        let sikpTemp = new Queryable<T>();
        if (skipIndex < this.structCount) {
            let i = 0;
            for (; i < skipIndex; i++)
                sikpTemp[i] = this[i];
            sikpTemp.structCount = i;
        }
        return sikpTemp;
    }

    SkipLast(skipIndex: number) {
        let sikpTemp = new Queryable<T>();
        if (skipIndex < this.structCount) {
            let i = 0;
            for (; i < (this.structCount - skipIndex); i++)
                sikpTemp[i] = this[skipIndex + i];
            sikpTemp.structCount = i;
        }
        return sikpTemp;
    }

    FirstOrDefault() {
        return this.FLst(1);
    }
    LastOrDefault() {
        return this.FLst(this.structCount);
    }
    protected FLst(index: number) {
        if (this.structCount)
            return this[index - 1];
        else
            return null;
    }

    //#region 增删改
    Remove() {
        this[this.structCount--] = null;
        return this;
    }

    Add(item: T) {
        this[this.structCount++] = item;
        return this;
    }
    //#endregion
    //#endregion

    //#region 迭代器
    [Symbol.iterator](): IterableIterator<T> {
        return this;
    };

    next(value: number = this.nextIdex++): IteratorResult<T> {
        if (this.structCount > value)
            return { value: this[value], done: false };
        else {
            this.nextIdex = 0;                      // 指向链顶部
            return { value: null, done: true };
        }
    }

    return?(): IteratorResult<T> {
        return { value: null, done: true };
    }
    //#endregion



    // some(func: Function, thisValue: T) {
    //     func(this[this.nextIdex], this.nextIdex, this, this)
    // }

    // map(func: Result2<T, number, any>) {
    //     for (let i = 0; i < this.structCount; i++)
    //         this[i] = func(this[i], i);
    //     return this;
    // }

    // forEach(func: Result2<T, number, any>) {
    //     for (let i = 0; i < this.structCount; i++)
    //         func(this[i], i);
    // }

    // slice(start: number, end: number) {
    //     let Temp: Queryable<T> = new Queryable<T>();
    //     for (let i = start; i < end; i++) {
    //         Temp.Add(this[i])
    //     }
    //     return Temp
    // }
}
